import { useIntl } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import Card from 'src/components/_common/Card/Card';

interface AttendanceSectionProps {
  className?: string;
}

export default function AttendanceSection({ className }: AttendanceSectionProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Card
      className={className}
      primary={false}
      onClick={() => navigate(`${location.pathname}/attendance`)}
      header={formatMessage({ id: 'attendance-page-title' })}
    />
  );
}
